import React from 'react';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import KenLoader from '../../GlobalComponents/KenLoader';
import axios from 'axios';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { ConfigOptions } from '../../interfaces/Common';
import AuthLayout from '../../Components/AuthLayout';
import AppLayout from '../../Components/AppLayout';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import storage from '../../storageService';
import FAQ from '../Service/components/FAQ';
import EditProfile from '../MyProfile/Components/PersonalDetails/Pages/EditProfile';
import Answers from '../Service/components/Questions/Answers';
import AssessmentAdding from '../Academics/Pages/Activities/Assessment';
import AssignmentForm from '../Academics/Pages/Activities/Assignment';
import ForumForm from '../Academics/Pages/Activities/Forum';
import AssignmentReview from '../Academics/Pages/Activities/Assignment/Components/Preview';
import DiscussionPortal from '../Academics/Pages/Activities/Forum/ForumDiscussions/ForumDiscussion';
import PageViewTracker from '../../MixPanel/PageViewTracker';
const ResourceFormComponent = React.lazy(() => import('../Academics/Components/ResourceFileUpload/index'));
const Home = React.lazy(() => import('../../Containers/Home/index'))
const AcademicsElaborate = React.lazy(() => import('../Academics/Pages/AcademicsElaborate'));
const CourseElaborate = React.lazy(() => import('../Academics/Pages/CourseElaborate'));
const Signup = React.lazy(() => import('../Auth/SignUp/index'));
const VerifyOTP = React.lazy(() => import('../Auth/VerifyOtp/index'));
const EmailConformation = React.lazy(() => import('../Auth/ConfirmEmail/index'));
const Login = React.lazy(() => import('../Auth/Login/index'));
const ForgotPassword = React.lazy(() => import('../Auth/ForgotPassword/index'));
const ConfirmPassword = React.lazy(() => import('../Auth/ConfirmPassword/index'));
const Events = React.lazy(() => import('../Events/index'));
const Academics = React.lazy(() => import('../../Containers/Academics'))
const QuestionBank = React.lazy(() => import('../Academics/QuestionBank/index'))
const Service = React.lazy(() => import('../Service/index'));
const TicketPreview = React.lazy(() => import('../Service/components/Ticket/TicketPreview'));
const RequestService = React.lazy(() => import('../Service/components/Requests/RequestService'));
const Test = React.lazy(() => import('../Test'));
const Settings = React.lazy(() => import('../Settings/index'));
const MyStudents = React.lazy(() => import('../MyStudents'));
const MySchedule = React.lazy(() => import('../MySchedule/index'))
const MyResourceEloborate = React.lazy(() => import('../Academics/Pages/resourceEloborateView'))
const StudentDetails = React.lazy(() => import('../MyStudents/Pages/studentdetails'));
const StudentInfo = React.lazy(() => import('../MyStudents/Pages/studentinfo'));
const AttendanceTabs = React.lazy(() => import('../Attendance/Tabs/index'));
const Attendance = React.lazy(() => import('../Attendance/index'));
const OverAllAttendance = React.lazy(() => import('../Attendance/components/overallAttendance'));
const FacultyCourses = React.lazy(() => import('../Attendance/Tabs/facultycourses'));
const MyProfile = React.lazy(() => import('../MyProfile'));
const PlanMyProgram = React.lazy(() => import('../PlanMyProgram/index'));
const SessionPlanner = React.lazy(() => import('../PlanMyProgram/Pages/sessionPlanner'));
const SessionSummary = React.lazy(() => import('../PlanMyProgram/Pages/sessionsummary'));
const AcademicsaddQuestion = React.lazy(() => import('../Academics/QuestionBank/AddQuestion/index'));


const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();

  const [forgotPassword, setForgotPassword] = useState(false);
  useEffect(() => {
    getConfig()
      .then((res: Array<ConfigOptions>) => {
        console.log('getConfig response:', res);
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        dispatch({ type: 'updateLogo', value: res[0]?.config?.logoURL });
        getAxiosInstance(res);
        console.log('Passed to getAxiosInstance:', res);
        try {
          axios({ method: 'get', baseURL: res[0]?.config?.tokenUrl })
            .then((response: any) => {
              // localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
              storage.set(KEY_AZURE_TOKEN, response.data.access_token);
            })
            .catch((err) => {
              return err;
            });
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err) => {
        console.error('error in config', err);
      });
  }, []);
  

  return config.apiBaseUrl === '' ? (
    <KenLoader />
  ) : (
    <>
      <PageViewTracker />
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />
        <Route path="/test" element={<Test />} />

        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword setForgotPassword={setForgotPassword} />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        {/* home */}
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Academics */}
        <Route
          path={routes.academics}
          element={
            <PrivateRoute>
              <AppLayout>
                <Academics />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.academicsElaborate}
          element={
            <PrivateRoute>
              <AppLayout>
                <AcademicsElaborate />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.courseElaborate}
          element={
            <PrivateRoute>
              <AppLayout>
                <CourseElaborate />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.resourceUpload}
          element={
            <PrivateRoute>
              <AppLayout>
                <ResourceFormComponent />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route path={routes.resourceEloboarate}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyResourceEloborate />
              </AppLayout>
            </PrivateRoute>
          } />
        <Route
          path={routes.AssessmentAdding}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssessmentAdding />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.AssignmentAdding}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssignmentForm />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.ForumAdding} element={
            <PrivateRoute>
              <AppLayout>
                <ForumForm />
              </AppLayout>
            </PrivateRoute>
          } />
        <Route
          path={routes.AssignmentReview}
          element={
            <PrivateRoute>
              <AppLayout>
                <AssignmentReview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.ForumDiscussion}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscussionPortal />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.QuestionBank}
          element={
            <PrivateRoute>
              <AppLayout>
                <QuestionBank />
              </AppLayout>
            </PrivateRoute>
          }
        />
         <Route
          path={routes.Addquestion}
          element={
            <PrivateRoute>
              <AppLayout>
                <AcademicsaddQuestion />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* My Students */}
        <Route
          path={routes.studentDetails}
          element={
            <PrivateRoute>
              <AppLayout>
                <StudentDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.studentInfo}
          element={
            <PrivateRoute>
              <AppLayout>
                <StudentInfo />
              </AppLayout>
            </PrivateRoute>
          }
        />        <Route
          path={routes.myProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.EditProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <EditProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Plan My program */}
        <Route
          path={routes.PlanMyProgram}
          element={
            <PrivateRoute>
              <AppLayout>
                <PlanMyProgram />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.SessionPlanner}
          element={
            <PrivateRoute>
              <AppLayout>
                <SessionPlanner />
              </AppLayout>
            </PrivateRoute>
          }
        />
         <Route
          path={routes.SessionSummary}
          element={
            <PrivateRoute>
              <AppLayout>
                <SessionSummary />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* My Students */}
        <Route
          path={routes.myStudents}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyStudents />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Attendance */}
        <Route
          path={routes.attendanceTabs}
          element={
            <PrivateRoute>
              <AppLayout>
                <AttendanceTabs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.attendance}
          element={
            <PrivateRoute>
              <AppLayout>
                <Attendance />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.facultyCourses}
          element={
            <PrivateRoute>
              <AppLayout>
                <FacultyCourses />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.overAllAttendance}
          element={
            <PrivateRoute>
              <AppLayout>
                <OverAllAttendance />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* My Schedule */}
        <Route
          path={routes.mySchedule}
          element={
            <PrivateRoute>
              <AppLayout>
                <MySchedule />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Events */}
        <Route
          path={`events/*`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* settings */}
        <Route
          path={`${routes.settings}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Service and Support */}

        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.serviceFAQ}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQ />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}/:serviceId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
